
import React, { FC } from 'react';
import s from './StepContent.module.css';
import { motion } from 'framer-motion';
import {ContentElement, InputField, StepData} from "../../OnboardingPage";
import CardItem from "../../entities/card-item/CardItem";
import Templates from "../templates/Templates";

interface StepContentProps {
    step: number;
    firstStepData: StepData[];
    linkedinToneList: StepData[];
    inputs: InputField[];
    currentTemplate: any;
    goalValue: string;
    setGoalValue: (value: string) => void;
    handleInputChange: (index: number, event: React.ChangeEvent<HTMLInputElement>) => void;
    handleCardItemSelection: (item: StepData) => void;
    toggleToneSelection: (text: string) => void;
}

const StepContent: FC<StepContentProps> = ({
                                               step,
                                               firstStepData,
                                               linkedinToneList,
                                               inputs,
                                               currentTemplate,
                                               goalValue,
                                               setGoalValue,
                                               handleInputChange,
                                               handleCardItemSelection,
                                               toggleToneSelection,
                                           }) => {


    const onboardingContent: Record<string, ContentElement[]> = {
        'Linkedin Post': [
            {
                header: "Let’s dive in! What's on your mind today?",
                text: 'Tell us what you want to write about, and we’ll help you shape it!',
                element: <textarea
                    value={goalValue}
                    onChange={(e)=>setGoalValue(e.target.value)}
                    placeholder={'e.g Life Hacks for Busy People'}
                    className={s.input} />,
            },
            {
                header: "Let's add some tone to your content",
                text: 'Choose up to 3 attributes how you want to wrap up and how your readers need to remember your post.',
                element: (
                    <div className={s.tone_container}>
                        {linkedinToneList.map((el) => (
                            <CardItem
                                key={el.text}
                                item={el}
                                onClick={() => toggleToneSelection(el.text)}
                            />
                        ))}
                    </div>
                ),
            },
        ],
    };

    if (step < 2) {
        return (
            <>
                <h3 className={s.header}>Hey there! Ready to create something magical?</h3>

                <p className={s.text}>You're crafting some content for.</p>

                <div className={s.list}>
                    {firstStepData.map(el => (
                        <CardItem key={el.text} item={el} onClick={() => handleCardItemSelection(el)}/>
                    ))}
                </div>
                {step === 1 && (
                    <div className={s.input_container}>
                        <p className={s.text}>Spice up your magic with up to 3 industries you're creating your
                            content for</p>
                        {inputs.map((input, i) => (
                            <input key={i}
                                   className={s.input}
                                   value={input.value}
                                   placeholder={input.placeholder}
                                   onChange={(event) => handleInputChange(i, event)}/>
                        ))}
                    </div>
                )}
            </>
        );
    }

    if (step === 2) {
        return (
            <motion.div
                key={`step-${step}`}
                initial={{opacity: 0, x: 50}}
                animate={{opacity: 1, x: 0}}
                transition={{duration: 0.2}}
                style={{width: '100%'}}
            >
                <h3 className={s.header}>And here where the magic starts to happen!</h3>
                <p className={s.text}>Choose one of the content types you want to create, and the rest is on us</p>
                <Templates currentTemplate={currentTemplate}/>
            </motion.div>
        );
    }

    if (currentTemplate?.title && onboardingContent['Linkedin Post']) { //if step > 2
        const content = onboardingContent['Linkedin Post'][step - 3];//fix when different onboarding
        if (content) {
            return (
                <motion.div
                    key={`step-${step}`}
                    initial={{opacity: 0, x: 50}}
                    animate={{opacity: 1, x: 0}}
                    transition={{duration: 0.2}}
                    style={{width: '100%'}}
                >
                    <h3 className={s.header}>{content.header}</h3>

                    <p className={s.text}>{content.text}</p>
                    {content.element}
                </motion.div>
            );
        }
    }

    return null;
};

export default StepContent;
